import React from "react";
import { graphql, navigate } from "gatsby";
import Page from "../components/page";
import { IndexQuery } from "./__generated__/IndexQuery";
import { SHOP_DISCOVER_PATH } from "../helpers/url";
import useLocalizedLocationPath from "../hooks/use-localized-location-path";
import { AUTO_REDIRECT_AUTHENTICATED_TO_SHOP } from "../helpers/feature-flags";
import useLocale from "../hooks/use-locale";
import { isUSSiteFromLocale } from "../helpers/region-on-locale";
import useIsAuthenticated from "../hooks/use-is-authenticated";

export default function IndexPage({ data }: { data: IndexQuery }) {
  // Auto-redirect authenticated users to Shop Discover
  const locale = useLocale();
  const getLocalizedPath = useLocalizedLocationPath();
  const isAuthenticated = useIsAuthenticated();
  if (
    AUTO_REDIRECT_AUTHENTICATED_TO_SHOP &&
    isAuthenticated &&
    isUSSiteFromLocale(locale)
  ) {
    navigate(getLocalizedPath(SHOP_DISCOVER_PATH));
  }

  return (
    <Page
      {...data.datoCmsWebPage}
      container={data.datoCmsWebPage.container as any}
    />
  );
}

export const query = graphql`
  query IndexQuery($locale: String!) {
    datoCmsWebPage(path: { eq: "" }, locale: { eq: $locale }) {
      ...WebPageFragment
    }
  }
`;
